/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';

import {
  GET_DASHBOARD_TEMPLATE,
  GET_DASHBOARD_TEMPLATE_SUCCESS,
  GET_DASHBOARD_TEMPLATE_FAILURE,
  CLEAR_DASHBOARD_TEMPLATE,
  UPDATE_DASHBOARD_TEMPLATE,
  UPDATE_DASHBOARD_TEMPLATE_SUCCESS,
  UPDATE_DASHBOARD_TEMPLATE_FAILURE,
  DELETE_DASHBOARD_TEMPLATE,
  DELETE_DASHBOARD_TEMPLATE_SUCCESS,
  DELETE_DASHBOARD_TEMPLATE_FAILURE,
} from '../actions/monitoringActionCreators';

const selectDashboardTemplate = state => get(state, 'monitoring.data');

// I have to clone this because it gets modified by the dashboard layout engine
export const getInstanceDashboard = createSelector([selectDashboardTemplate], dashboardTemplate =>
  cloneDeep(dashboardTemplate)
);

export const monitoringReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_DASHBOARD_TEMPLATE:
      return {
        ...state,
        data: null,
        fetchDataError: null,
        fetchingData: true,
        updatingData: false,
        updateDataError: null,
      };
    case CLEAR_DASHBOARD_TEMPLATE:
    case DELETE_DASHBOARD_TEMPLATE_SUCCESS:
      return {
        ...state,
        data: null,
        fetchDataError: null,
        fetchingData: false,
      };
    case DELETE_DASHBOARD_TEMPLATE:
      return {
        ...state,
        data: null,
        fetchDataError: null,
        fetchingData: true,
      };
    case GET_DASHBOARD_TEMPLATE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        fetchDataError: null,
        fetchingData: false,
      };
    case GET_DASHBOARD_TEMPLATE_FAILURE:
      return {
        ...state,
        data: null,
        fetchDataError: action.payload,
        fetchingData: false,
      };
    case UPDATE_DASHBOARD_TEMPLATE:
      return {
        ...state,
        updateDataError: null,
        updatingData: true,
      };
    case UPDATE_DASHBOARD_TEMPLATE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        updateDataError: null,
        updatingData: false,
      };
    case DELETE_DASHBOARD_TEMPLATE_FAILURE:
    case UPDATE_DASHBOARD_TEMPLATE_FAILURE:
      return {
        ...state,
        updateDataError: action.payload,
        updatingData: false,
        fetchingData: false,
      };

    default:
      return state;
  }
};

export const getAssetDashboardsUpdatingDataError = state =>
  get(state, 'monitoring.updateDataError');
